export default __webpack_public_path__ + "static/media/tartar-sauce.0db9c6cd.jpg";